import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { gmToolNew } from "@/mixins/index";
import { template } from "lodash";
import { vipEmailsTemplateList, vipSendEmail } from "@/api/gmtool/packageCode";
export default {
  mixins: [gmToolNew],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogShow: false,
      templateNameList: [],
      paramsData: {
        template_id: '',
        uids: []
      },
      role_id: '',
      rules: {
        template_id: [{
          required: true,
          message: this.$t('pleaseSelectTemplateName'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      console.log("row===", row);

      if (row.length) {
        row.forEach(function (item) {
          console.log("this.paramsData", _this.paramsData);

          _this.paramsData.uids.push({
            server_id: item.server_id,
            role_id: item.role_id
          });
        });
      }

      vipEmailsTemplateList({
        page_size: 1000
      }).then(function (res) {
        if (res.code == 200) {
          _this.templateNameList = res.data.data;
        }
      });
      this.dialogShow = true;
    },
    clearData: function clearData() {
      this.paramsData = {
        template_id: '',
        uids: []
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var params = {
            env_id: _this2.szgmEnv.length ? _this2.szgmEnv[0].id : '',
            game_id: _this2.rawData.game_id
          };
          vipSendEmail(_objectSpread(_objectSpread(_objectSpread({}, _this2.paramsData), params), _this2.prod)).then(function (res) {
            if (res.code == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: "success"
              });

              _this2.dialogShow = false;
            }
          });
        }
      });
    }
  }
};